/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Grid, Skeleton, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState, useAppDispatch } from "@store/store";
import { InactivityHandler } from "@components/InactivityHandler";
import ButtonExpedienteForm from "@components/ButtonExpedienteForm";
import { BOFU_TABS_CONFIG } from "@helpers/constantes";
import { ModalExpediente } from "@components/CustomModalExpediente";
import CustomRightImage from "@components/CustomRightImagev2";
import TabBofu from "@components/TabBofu/TabBofu";
import DocumentsTabBofu from "@components/TabBofu/DocumentsTabBofu";
import { setBofuTabEmpresaDocument } from "@store/slices/bofuSlice";
import ButtonContinue from "@components/TabBofu/ButtonContinue";
import { CustomCompanyName } from "@components/CustomCompanyName";

const AvanceExpedienteDigital: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));
  const dispatch = useAppDispatch();

  const application = useSelector((state: RootState) => state.register.application);
  const bofuTabs = useSelector((state: RootState) => state.bofu.bofu_tabs_obj);
  const bufuLoading = useSelector((state: RootState) => state.bofu.isLoading);

  const [openModalValidacionIndentidad, setOpenModalValidacionIdentidad] = useState(false);
  const [openModalSolicitudCredito, setOpenModalSolicitudCredito] = useState(false);
  const [openModalEmpresa, setOpenModalEmpresa] = useState(false);

  const handleClickSolicitudCredito = () => {
    navigate("/producto/creditosimple/solicitud_credito_1");
  };

  return (
    <>
      <Grid container height="100%">
        <Grid item xs={12} md={8} mt={2}>
          <Box textAlign={"center"} mx={4}>
            <InactivityHandler />

            <CustomCompanyName />

            <TabBofu />

            {bufuLoading ? (
              <Box mt={4}>
                <Skeleton variant="rectangular" height={100} sx={{ borderRadius: 2 }} />
              </Box>
            ) : (
              <Box>
                <Typography
                  mt={4}
                  variant={isMobileOrTablet ? "body2" : "body1"}
                  fontWeight={700}
                  color={theme?.palette?.primary?.dark}
                >
                  Muy bien, ahora llena los formatos relacionados a la empresa
                </Typography>

                <Box mt={2} display="flex" justifyContent="space-between" alignItems="center">
                  <Typography variant="body1" sx={{ flex: 1, textAlign: "left" }} color={theme?.palette?.primary?.dark}>
                    Solicitud de crédito
                  </Typography>

                  <ButtonExpedienteForm
                    formStatus={application?.loan_application_information_status}
                    onClick={handleClickSolicitudCredito}
                  />
                </Box>

                <Box mt={2} display="flex" justifyContent="space-between" alignItems="center">
                  <Typography variant="body1" sx={{ flex: 1, textAlign: "left" }} color={theme?.palette?.primary?.dark}>
                    Referencias
                  </Typography>

                  <ButtonExpedienteForm
                    formStatus={application?.references_status}
                    onClick={() => navigate("/producto/creditosimple/referencias_clientes")}
                  />
                </Box>

                <Box mt={2} display="flex" justifyContent="space-between" alignItems="center">
                  <Typography variant="body1" sx={{ flex: 1, textAlign: "left" }} color={theme?.palette?.primary?.dark}>
                    Información bancaria
                  </Typography>

                  <ButtonExpedienteForm
                    formStatus={application?.bank_information_status}
                    onClick={() => navigate("/producto/creditosimple/info_bancaria_empresa")}
                  />
                </Box>

                <Typography mt={4} variant={isMobileOrTablet ? "body2" : "body1"} color={theme?.palette?.primary?.dark}>
                  Necesitarás tener la identificación a la mano y tomar un par de selfies
                </Typography>

                <Typography
                  mt={4}
                  variant={isMobileOrTablet ? "body2" : "body1"}
                  fontWeight={700}
                  color={theme?.palette?.primary?.dark}
                >
                  Ahora carga los documentos relacionados a la empresa
                </Typography>

                <DocumentsTabBofu
                  tabCode={BOFU_TABS_CONFIG.tab_empresa.code}
                  documents={bofuTabs?.empresa?.documents || []}
                  onChange={({ document, newValue }) => {
                    dispatch(setBofuTabEmpresaDocument({ document, newValue }));
                  }}
                />

                <Box mt={4}>
                  <ButtonContinue tabCode={BOFU_TABS_CONFIG.tab_empresa.code} />
                </Box>
              </Box>
            )}
          </Box>
        </Grid>
        {!isMobileOrTablet && (
          <Grid item xs={12} md={4}>
            <CustomRightImage />
          </Grid>
        )}
      </Grid>

      <ModalExpediente
        type="solicitud_credito"
        openModal={openModalSolicitudCredito}
        closeModal={() => setOpenModalSolicitudCredito(false)}
      />

      <ModalExpediente
        type="identity_validation_aval"
        openModal={openModalValidacionIndentidad}
        closeModal={() => setOpenModalValidacionIdentidad(false)}
      />

      <ModalExpediente
        type="dictamen_not_available"
        openModal={openModalEmpresa}
        closeModal={() => setOpenModalEmpresa(false)}
      />
    </>
  );
};

export default AvanceExpedienteDigital;
